<template>
  <nav
    id="main-navigation"
    class="mb-3">
    <!-- Content -->
    <v-btn
      class="plain py-2 px-5 justify-start"
      to="/content"
      block>
      <v-icon class="mx-5">mdi-content-duplicate</v-icon>
      Content
    </v-btn>
    <!-- / Content -->

    <!-- Blog -->
    <v-btn
      class="plain py-2 px-5 justify-start"
      to="/blog"
      block>
      <v-icon class="mx-5">mdi-post-outline</v-icon>
      Blog
    </v-btn>
    <!-- / Blog -->

    <!-- Files -->
    <v-btn
      class="plain py-2 px-5 justify-start"
      to="/files"
      block>
      <v-icon class="mx-5">mdi-file-multiple</v-icon>
      Files
    </v-btn>
    <!-- / Files -->

    <!-- Project Settings -->
    <v-btn
      class="plain py-2 px-5 justify-start"
      to="/projectdetails"
      block>
      <v-icon class="mx-5">mdi-cog</v-icon>
      Project Settings
    </v-btn>
    <!-- / Project Settings -->
  </nav>
</template>

<script>
export default {
  name: 'MainNavigation',
};
</script>

<style lang="scss"></style>
